import { Container } from '@volkswagen-onehub/components-core';
import styled from 'styled-components';
import { COLOR_TOKEN } from '../../../../../helpers/color-tokens';

export const HuchaCardBackground = styled(Container)`
	border-radius: 16px;
	background: ${COLOR_TOKEN.gradient.radial};
	padding-top: var(--size-dynamic0130);
	padding-bottom: var(--size-dynamic0130);
	padding-left: var(--size-dynamic0130);
	padding-right: var(--size-dynamic0130);
`;

export const PopupHuchaCardBackground = styled(Container)`
	border-radius: 16px;
	background: ${COLOR_TOKEN.gradient.radial};
	padding: 46px 24px;

	/* Mobile */
	@media (max-width: 1599px) {
		padding: 24px 20px;
	}
`;

export const PopupHuchaCardBackground2 = styled(Container)`
	border-radius: 16px;
	background: ${COLOR_TOKEN.gradient.radial};
	padding: 46px;

	/* Mobile */
	@media (max-width: 959px) {
		padding: 24px 20px;
	}
`;

export const PdfHuchaCardBackground = styled(Container)`
	border-radius: 16px;
	background: ${COLOR_TOKEN.gradient.radial};
	padding: 24px;
`;

export const PdfHuchaCardBackground2 = styled(Container)`
	border-radius: 16px;
	background: ${COLOR_TOKEN.gradient.radial};
	padding: 24px 46px;
`;
